import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supplierNetworkHeroImage } from '@/mocks/supplierNetwork';

export default function Hero() {
  const { t } = useTranslation('supplierNetwork');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section className="relative w-full overflow-hidden flex items-center min-h-[336px] md:min-h-[400px] lg:min-h-[480px]">
      {/* Background image */}
      <img
        src={supplierNetworkHeroImage}
        alt={t('hero.imageAlt')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Dark overlay for text contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40" />

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-8 md:py-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div
            className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 border border-white/15 mb-4 md:mb-6 transition-all duration-700 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <div className="w-1.5 h-1.5 rounded-full bg-warm-500" />
            <span className="text-xs md:text-sm font-medium text-white/80 tracking-wide uppercase">
              {t('hero.badge')}
            </span>
          </div>

          {/* Title */}
          <h1
            className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-4 md:mb-5 transition-all duration-700 delay-100 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            {t('hero.title')}
          </h1>

        </div>
      </div>
    </section>
  );
}